import React from "react";
import { Canvas } from "@react-three/fiber";

import { meterToCanvas } from "./zoomHelper";
import useData from "../app/useData";

import CameraHandler from "./CameraHandler";
import Container from "./Container";
import Element from "./Element";

const View: React.FC<{}> = () => {
	const {
		elementEditing,
		containerEditingId: containerId,
		elements: elementsMap,
		containers,
		elementsInContainers,
		selectElement
	} = useData();

	const container = containerId && containers.get(containerId);

	if (!container) {
		return null;
	}

	const { content, width, height, depth } = container;
	const elements: Array<{ position: ElementPositionType; element: ElementDefinitionType }> = [];
	content.forEach(eltId => {
		const element = elementsMap.get(eltId);
		const ref = elementsInContainers.get(eltId);
		if (element && ref) {
			return elements.push({ position: ref.position, element });
		}
	});

	// Custom camera:
	// https://github.com/pmndrs/react-three-fiber/blob/master/markdown/api.md#defaults-that-the-canvas-component-sets-up
	// https://github.com/pmndrs/react-three-fiber/blob/master/markdown/recipes.md#using-your-own-camera-rig
	const camera: {
		fov: number;
		near: number;
		far: number;
		position: Vector;
	} = {
		fov: 60,
		near: 0.1,
		far: 1000,
		position: [2 * meterToCanvas, 2 * meterToCanvas, 3 * meterToCanvas]
	};
	// const camera = undefined;
	return (
		<Canvas camera={camera} /*orthographic*/>
			<CameraHandler
				enableZoom={true}
				enablePan={true}
				enableDamping
				dampingFactor={0.2}
				minDistance={1 * meterToCanvas}
				maxDistance={500 * meterToCanvas}
				minPolarAngle={0}
				maxPolarAngle={Math.PI}
				// autoRotate
				// rotateSpeed={0.5}
			/>
			<ambientLight />
			<pointLight position={[10 * meterToCanvas, 100 * meterToCanvas, 50 * meterToCanvas]} />
			<Container
				width={width * meterToCanvas}
				height={height * meterToCanvas}
				depth={depth * meterToCanvas}
			/>
			{elements.map(({ element, position }) => (
				<Element
					key={element.id}
					element={element}
					position={position}
					onSelectElement={selectElement}
					active={element.id === elementEditing?.elementId}
				/>
			))}
		</Canvas>
	);
};

export default View;
